import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Gallery } from "@/pages/Home";
import useLenis from "@/hooks/useLenis";
import api from "@/lib/api";

export default function GalleryPage() {
  useLenis();
  const [items, setItems] = useState([]);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/content?type=image").then((r) => setItems(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-imi-bg text-imi-text min-h-screen">
      <Header />
      <main className="pt-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-imi-text/50 hover:text-imi-gold transition-colors">
            <ArrowLeft size={16} /> Back home
          </Link>
        </div>
        {items.length > 0 ? (
          <Gallery items={items} />
        ) : (
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-32 text-center text-imi-text/40">No images yet.</div>
        )}
      </main>
      <Footer settings={settings} />
    </div>
  );
}
